import { helpers } from '../helpers.js';

var profile = {
	selectors: { },
	ordersFilters: {
		date_from: '',
		date_to: '',
		products: [],
		users: [],
		page: 1,
		per_page: 20,
		order_by: 'ID',
		order: 'DESC'
	},
	reportsFilters: {

	},

	init: function () {
		var self = this;
		/*
		TODO: Dočasně vypnutý přepínač nákup prodej. Pro ostatní související části hledej string Ggldfjgfd4589
		jQuery( '[name="user_is_selling"]' ).on( 'change', function(){
			const check = jQuery( this );

			helpers.setCookie( 'api_user_is_selling', ( check.is( ':checked' ) ) ? 'yes' : 'no', 24 );
		});
		*/

		self.loadTabEvents();

		if( typeof profileVars === 'undefined' ) {
			return false;
		}

		self.openSwitchSelects();
		self.switchUserEvents();
		self.setupReportsEvents();
		self.setupOrdersFilterEvents();
		

		if( ! profileVars.token ) {
			return false;
		}

		if( ! document.querySelector( '.js-primaryAddress' ) ) {
			return false;
		}

		//self.testCall();

		self.newAddress();
		self.saveAddress();
		self.loadAddresses( false );
		
		self.deleteAccount();

		//funkci na reset othersAddresess -> znova volat -> loadAddresses??? s vyjímkou pro primary?
		//při přidání/smazání
	},

	deleteAccount: function() {
		jQuery( '[href="#really-delete-account"]' ).on( 'click', function(){
			jQuery.fancybox.open({
				src: '#really-delete-account',
				type : 'inline',
				touch: false,
			});
		});
		
		jQuery( '[data-deleteacc]' ).on( 'click', function(){
			helpers.pctApiCall({
				action: 'delete_user_account',
			}).then( response => {
				if( ! response.success ) {
					console.error( 'Error: ', response.data.message ); 
					return false;
				}
	
				window.location = response.data.url;
			}).catch(error => {
				console.error( 'Error: ', error); 
			});
		});
	},

	loadTabEvents: function() {
		var self = this;

		if( document.querySelectorAll( '.js-profileTabs a' ).length == 0 ) {
			return false;
		}
		
		document.querySelectorAll( '.js-profileTabs a' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {
				e.preventDefault();

				let anchor = e.target.getAttribute( 'href' ).replace( '#', '' );
				self.switchTab( anchor );
			});
		});
	},

		switchTab: function( toTab ) {
			var self = this;

			if( ! document.querySelector( `#${toTab}` ) ) {
				return false;
			}

			document.querySelector( '.js-profileTabs li.active' ).classList.remove( 'active' );
			document.querySelector( '.profile-tabs__tab.active' ).classList.remove( 'active' );
			
			document.querySelector( `.js-profileTabs li:has( a[href="#${toTab}"] )` ).classList.add( 'active' );
			document.querySelector( `#${toTab}.profile-tabs__tab` ).classList.add( 'active' );
		},

	pctApiCall: function( type, address, data, ) {
		//console.log( data );

	//	return;
		return new Promise((resolve, reject) => {
		jQuery.ajax({
			type: type,
			url: profileVars.api_url + address,
		//	dataType: 'json',
			cache: false,
			contentType: 'application/json', 
			beforeSend: function(xhr) {
				xhr.setRequestHeader("Authorization", `Bearer ${profileVars.token}`);
			},
			data: JSON.stringify( data ),
			success: function( response ){
				resolve(response);
			},
			error: function( response ){
				//console.log( response );
				reject(response);
			},
			complete: function( response ){
				// console.log( response );
			}
			}).done(function(data, textStatus, jqXHR) {
				//console.log("Success: ", data);
		 	 }).fail(function(jqXHR, textStatus, errorThrown) {
				// console.log("Error: ", jqXHR);
				// console.log("Error: ", textStatus);
				console.log("Error: ", errorThrown);
		  	}).always(function() {

		  	});
		});
	},

	showMessage: function( message, type, primary ) {
		var self = this;
		if( primary ) {

			let primaryMessage = document.querySelector(`.js-primaryAddressMessage`);
			primaryMessage.classList.remove('d-none');
			primaryMessage.innerHTML = message;
			
			if( type != "success" ) {
				primaryMessage.classList.add('error');
			}
			else {
				primaryMessage.classList.remove('error');
			}
		}
		else {
			document.querySelector(`.js-otherAddressMessage`).classList.remove('d-none');
			document.querySelector(`.js-otherAddressMessage`).innerHTML = message;

			self.loadAddresses( true );
		}
	},

	saveAddress: function() {
		var self = this;

		let addressesForms = document.querySelectorAll('.js-addressForm');
 
		if( addressesForms.length ) {
			addressesForms.forEach( form => {
				form.addEventListener('submit', function(e) {
					e.preventDefault();

					document.querySelector(`.js-primaryAddressMessage`).classList.add('d-none');
					document.querySelector(`.js-otherAddressMessage`).classList.add('d-none');

					let form = e.target;
					let formData = new FormData(form);
					let primary = form.dataset.primary == 1 ? true : false;


					formData.append('primary', primary);
					formData.append('vatId',  formData.get('dic'));

					let data = {};
					formData.forEach((value, key) => data[key] = value);

					let addressId = form.dataset.addressId;

					let message = "";
					let type = "";

					if( !addressId ) {
						//NEW
						self.pctApiCall( 'POST', `/v1/profile/address/users/${profileVars.token_data.sub}`, data).then(data => {
							message = "Adresa byla úspěšně uložena";
							type = "success";			
							
							self.showMessage( message, type, primary );
						}).catch(error => {
							console.error("Error fetching addresses:", error); 
							message = "Adresa nebyla uložena";
							message = error;
							type = "error";	
							self.showMessage( message, type, primary );
						});

						// console.log( message);
						// console.log(type);

					} else {
						//EDIT
						self.pctApiCall( 'PUT', `/v1/profile/address/${addressId}`, data).then(data => {
							// console.log("asdasdasd");
							message = "Adresa byla úspěšně uložena.";
							type = "success";	
							self.showMessage( message, type, primary );
						}).catch(error => {
							message = "Adresa nebyla uložena";
							message = error;
							type = "error";	
							self.showMessage( message, type, primary );
						});
					}



					jQuery.fancybox.close();
				});
			});
		}
	},

	
	loadAddresses: function( onlyOthers = false) {
		var self = this;

		console.log( 'da' );

		// console.log("loadAddresses");
		if( typeof pctUsrVars != 'undefined' && pctUsrVars.hasOwnProperty('api_user_detail')  ) {

            let org_addresses = false;

            if (pctUsrVars.api_user_detail.hasOwnProperty('organizationAddresses')) {
                org_addresses = pctUsrVars.api_user_detail.organizationAddresses;
            }
			// console.log(pctUsrVars.api_user_detail);
			org_addresses = typeof org_addresses !== 'undefined' ? org_addresses: false;
			let addresses = org_addresses ? org_addresses : pctUsrVars.api_user_detail.userAddresses;
			self.initializeAddressForm(addresses);
		}else{
			self.pctApiCall('GET', `/v1/profile/address/me`, "").then(addresses => {
				self.initializeAddressForm(addresses);
				self.openAddress();
				self.removeAddress();
			}).catch(error => {
				console.error("Error fetching addresses:", error);
			});
		}
	},

	initializeAddressForm: function(addresses) {
		// console.log(addresses);

		// console.log( 'yep' );

		const otherAddresses = document.querySelector('.js-otherAddresses');
		otherAddresses.innerHTML = '';

		addresses.forEach(address => {
			if (address.primary) {

				document.querySelector(`.js-primaryAddress`).dataset.addressId = address.id;
				for (const key in address) {
					const input = document.querySelector(`.js-primaryAddress [name="${key}"]`);
					if ( input != null) {
						input.value = address[key];
					}
				}

			} else {
				const listItem = document.createElement('li');
				listItem.textContent = address.id;
				listItem.dataset.addressId = address.id;
				listItem.innerHTML = `<div><h3>${address.fullName}</h3><a href='#' class='js-editAddress'>upravit</a><a href='#' class='js-removeAddress'>smazat</a></div><p>${address.street}, ${address.postalCode}, ${address.city}, ${address.country}</p></div>`

				listItem.dataset.address = JSON.stringify(address);
				otherAddresses.appendChild(listItem);
			}
		});

		if (otherAddresses && otherAddresses.children.length === 0) {
			const li = document.createElement('li');
			li.className = 'empty';
			li.textContent = pctVars.l18n.address.no;
			otherAddresses.appendChild(li);
		}
	},

	openAddress: function() {
		var self = this;
		
		let editAddresses = document.querySelectorAll('.js-editAddress');
 
		if( editAddresses.length ) {
			editAddresses.forEach( editButton => {
				editButton.addEventListener('click', function(e) {
					e.preventDefault();

					const address = editButton.closest( 'li' ); 

					const addressData = JSON.parse(address.dataset.address);
					
					document.querySelector(`.js-otherAddress`).dataset.addressId = addressData.id;

					for (const key in addressData) {
						const input = document.querySelector(`.js-otherAddress [name="${key}"]`);
						if ( input != null) {
							input.value = addressData[key];
						}
					}

					self.openOtherAddressModal();
				});
			});
		}
	},

	newAddress: function() {
		var self = this;
		const newAddress = document.querySelector('.js-newAddress');
		
		if( newAddress ) {
			newAddress.addEventListener('click', function(e) {
				e.preventDefault();
				document.querySelector(`.js-otherAddress`).removeAttribute("data-addressId");

				const otherAddressInputs = document.querySelectorAll(`.js-otherAddress [name]`);
				if( otherAddressInputs.length ) {
					otherAddressInputs.forEach(input => {
						input.value = ""
					});
				}

				document.querySelector(`.js-otherAddress [name=country]`).value = "CZ";

				self.openOtherAddressModal();
			});
		}
	},

	openOtherAddressModal: function() {
		jQuery.fancybox.open({
			src  : '.other-address-modal', // Selector to the modal content container
			type : 'inline', // Content type
			touch: false,
		});
	},

	openReportGenerateModal: function() {
		// console.log('openReportGenerateModal');
		jQuery.fancybox.open({
			src  : '.generate_report_modal', // Selector to the modal content container
			type : 'inline', // Content type
			touch: false,
		});
	},

	openOrdersFilterModal: function() {
		// console.log('openOrdersFilterModal');
		jQuery.fancybox.open({
			src  : '.orders_filter_modal', // Selector to the modal content container
			type : 'inline', // Content type
			touch: false,
		});
	},

	removeAddress: function() {
		var self = this;
		let removeAddresses = document.querySelectorAll('.js-removeAddress');
 
		if( removeAddresses.length ) {
			removeAddresses.forEach( removeButton => {
				removeButton.addEventListener('click', function(e) {
					e.preventDefault();

					const address = removeButton.closest( 'li' ); 
					const addressData = JSON.parse(address.dataset.address);
					const addressId = addressData.id;

					address.classList.add('loading');

					self.pctApiCall( 'DELETE', `/v1/profile/address/${addressId}`, {}).then(data => {

						let message = "Adresa byla smazána";
						let type = "success";	
						self.showMessage( message, type, false );
					}).catch(error => {
						console.error("Error fetching addresses:", error); 
					});

				});
			});
		}

	},

	getFilteredOrders: async function() {
		var self = this;
		var filteredOrders = [];

		let data = {
			'action' : 'get_filtered_orders',
			'date_from': profile.ordersFilters.date_from,
			'date_to': profile.ordersFilters.date_to,
			'products': JSON.stringify(profile.ordersFilters.products),
			'users': JSON.stringify(profile.ordersFilters.users),
			'order_by': profile.ordersFilters.order_by,
			'order': profile.ordersFilters.order,
			'page' : profile.ordersFilters.page,
			'per_page' : profile.ordersFilters.per_page
		};

		await jQuery.ajax({
			type: 'POST',
			url: pctVars.ajax_url,
			data: data,
			success: function( response ){
				// console.log( response.data)
				filteredOrders = response.data;
			},
			error: function( response ){
				console.log( response );
			},
			complete: function( response ){
				// console.log( response );
			}
		});

		return filteredOrders;
	},

	generateReport: function(dateFrom = '', dateTo = '', products = [], isOwnReport) {
		let data = {
			'action' : 'generate_sales_report',
			'date_from': dateFrom,
			'date_to': dateTo,
			'products': JSON.stringify(products),
			'own_report': isOwnReport
		};

		jQuery.ajax({
			type: 'POST',
			url: pctVars.ajax_url,
			data: data,
			success: function( response ){
				location.reload();
			},
			error: function( response ){
				console.log( response );
			},
			complete: function( response ){
				// console.log( response );
			}
		});

		return filteredOrders;
	},

	switchUserEvents: function() {
		if( document.querySelectorAll( '.js-switchProfile' ) ) {
			document.querySelectorAll( '.js-switchProfile' ).forEach(function (item) {
				item.addEventListener( 'click', function(e) {
					e.preventDefault();
                    if (item.dataset.type == "organization" && !item.classList.contains('profile-profile__status_active')) {
                        return;
                    }
					// console.log('send ajax');
					let userId = e.currentTarget.dataset.id !== undefined ? e.currentTarget.dataset.id : '';
					let isOrganization = e.currentTarget.dataset.type === 'organization' ? "1" : "0";

					let data = {
						'action': 'switch_api_user',
						'user_id': userId,
						'is_organization': isOrganization
					};

					// console.log(e.currentTarget);

					jQuery.ajax({
						type: 'POST',
						url: pctVars.ajax_url,
						data: data,
						success: function( response ){
							location.reload();
						},
						error: function( response ){
							console.log( response );
						},
						complete: function( response ){
							// console.log( response );
						}
					});
				});
			})
		}
	},

	openSwitchSelects: function() {
		// console.log(pctVars);
		if( document.querySelector( '.js-openProfileSelects' ) ) {
			document.querySelector( '.js-openProfileSelects' ).addEventListener( 'click', function(e) {
				// console.log('click');
				e.preventDefault();
				document.querySelector( '.profile-profile__switch-select' ).classList.toggle( 'active' );
			});
		}
	},

	setupOrdersFilterEvents: function() {
		jQuery( '.js-filterOrdersModal' ).on( 'click', function( event ){
			event.preventDefault();
			profile.openOrdersFilterModal();
		});

		let ordersFilter = document.querySelectorAll('.js-ordersFilter');
		let filteredOrders = [];

		if( ordersFilter.length ) {
			ordersFilter.forEach(form => {
				form.addEventListener('submit', async function (e) {
					e.preventDefault();

					let date_from = this.querySelector('[name="date-from"]').value;
					let date_to = this.querySelector('[name="date-to"]').value;
					let products = profile.getMultiselectAsArray(jQuery('.products-multiselect'));
					let users = profile.getMultiselectAsArray(jQuery('.users-multiselect'));

					profile.ordersFilters.date_from = date_from;
					profile.ordersFilters.date_to = date_to;
					profile.ordersFilters.products = products;
					profile.ordersFilters.users = users;
					profile.ordersFilters.page = 1;

					 profile.getFilteredOrders().then(filteredOrdersData => {
						 filteredOrders = filteredOrdersData['orders'];
						 profile.fillOrdersTable(filteredOrders);
						 let totalPages = filteredOrdersData['total_pages'];
						 let currentPage = filteredOrdersData['current_page'];
						// console.log(totalPages)
						 profile.setPaginationPages(totalPages, currentPage);
						 jQuery.fancybox.close();
					});
				});
			});
		}

		jQuery('#ordersPagination').on('click', 'a', function(e) {
			e.preventDefault();
			let element = jQuery(this);

			if(element.hasClass('selected')) return;

			profile.ordersFilters.page = element.data('page');

			profile.getFilteredOrders().then(filteredOrdersData => {
				filteredOrders = filteredOrdersData['orders'];
				profile.fillOrdersTable(filteredOrders);
				jQuery('#ordersPagination a.selected').removeClass('selected');
				element.addClass('selected');

				let totalPages = filteredOrdersData['total_pages'];
				let currentPage = filteredOrdersData['current_page'];
				profile.setPaginationPages(totalPages, currentPage);
			});
		});

		jQuery('.js-sortDate').on('click', function(e) {
			e.preventDefault();

			jQuery('.sortable.sort-active').removeClass('sort-active');
			jQuery(this).addClass('sort-active');

			if(profile.ordersFilters.order_by == 'date') {
				profile.ordersFilters.order = profile.ordersFilters.order == 'DESC' ? 'ASC' : 'DESC';
			}else{
				profile.ordersFilters.order_by = 'date';
				profile.ordersFilters.order = 'DESC';
			}

			profile.getFilteredOrders().then(filteredOrdersData => {
				e.currentTarget.dataset.order = profile.ordersFilters.order;
				filteredOrders = filteredOrdersData['orders'];
				profile.fillOrdersTable(filteredOrders);

				let totalPages = filteredOrdersData['total_pages'];
				let currentPage = filteredOrdersData['current_page'];
				profile.setPaginationPages(totalPages, currentPage);
			});
		});

		jQuery('.js-sortOrderId').on('click', function(e) {
			e.preventDefault();

			jQuery('.sortable.sort-active').removeClass('sort-active');
			jQuery(this).addClass('sort-active');

			if(profile.ordersFilters.order_by == 'ID') {
				profile.ordersFilters.order = profile.ordersFilters.order == 'DESC' ? 'ASC' : 'DESC';
			}else{
				profile.ordersFilters.order_by = 'ID';
				profile.ordersFilters.order = 'DESC';
			}



			profile.getFilteredOrders().then(filteredOrdersData => {
				e.currentTarget.dataset.order = profile.ordersFilters.order;
				filteredOrders = filteredOrdersData['orders'];
				profile.fillOrdersTable(filteredOrders);

				let totalPages = filteredOrdersData['total_pages'];
				let currentPage = filteredOrdersData['current_page'];
				profile.setPaginationPages(totalPages, currentPage);
			});
		});
	},

	setPaginationPages: function(totalPages, actualPage) {
		jQuery('.pagination_pages').html('');
		for(let i = 1; i <= totalPages; i++) {
			jQuery('.pagination_pages').append(`<a href="#" data-page="${i}" class="${i == actualPage ? 'selected' : ''}">${i}</a> `);
		}
	},

	fillOrdersTable: function(orders){
		let ordersList = jQuery('tbody.orders-list');
		ordersList.html('');
		if(orders.length > 0) {
			orders.forEach(order => {
				let date = new Date(order.date_created.date); // Převedeme řetězec na objekt Date
				let formattedDate = `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;
				ordersList.append(`<tr>
				<td><a href="${order.link}">${order.id}</a></td>
				<td>${formattedDate}</td>
				<td>${order.sell_type}</td>
				<td>${order.status}</td>
				<td>${order.total} ${order.currency_symbol}</td>
				</tr>`);
			});
		}else{

		}
	},

	setupReportsEvents: function() {
		let userVariables = typeof pctUsrVars != 'undefined' ? pctUsrVars : false;
		jQuery( '.js-generateReportOpenModal' ).on( 'click', function( event ){
			event.preventDefault();
			profile.openReportGenerateModal();
		});

		let generateReport = document.querySelectorAll('.js-generateReport');

		if( generateReport.length ) {
			generateReport.forEach(form => {
				form.addEventListener('submit', function (e) {
					e.preventDefault();

					let date_from_elm = this.querySelector('[name="date-from"]');
					let date_to_elm = this.querySelector('[name="date-to"]');

					let date_from = date_from_elm.value;
					let date_to = date_to_elm.value;

					if(date_to_elm.classList.contains('inactive')) {
						date_to = date_from;
					}

					let products = profile.getMultiselectAsArray(jQuery('.products-multiselect'));
					console.log(jQuery('input#own-report-checkbox'))
					let isOwnReport = jQuery('input#own-report-checkbox').length > 0 && jQuery('input#own-report-checkbox').is(':checked') ? 1 : 0

					console.log(isOwnReport)
					profile.generateReport(date_from, date_to, products, isOwnReport);
				});
			});
		}

		jQuery( '.js-reportLink' ).on( 'click', function( event ){
			event.preventDefault();
			let $target = jQuery( this );
			let reportId = $target.attr('data-report-id');
			const filename = reportId + '.csv';

			let data = {
				'action': 'get_csv_for_download',
				'reportId': reportId,
			};

			jQuery.ajax({
				type: 'POST',
				url: pctVars.ajax_url,
				data: data,
				success: function( response ){
					let blob = new Blob([response.data.csv], { type: 'text/csv;charset=utf-8;' });

					let url = URL.createObjectURL(blob);
					let link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', filename); // Set the file name for the download
					document.body.appendChild(link); // Required for Firefox
					link.click(); // Trigger the download
					document.body.removeChild(link); // Clean up
				},
				error: function( response ){
					console.log( response );
				},
				complete: function( response ){
					// console.log( response );
				}
			});
		});

		jQuery( '.js-reportPdfLink' ).on( 'click', function( event ){
			event.preventDefault();
			let $target = jQuery( this );
			let fileId = $target.attr('data-report-id');
			const filename = fileId + '.pdf';

			let data = {
				'action': 'get_pdf_for_download',
				'fileId': fileId,
			};

			jQuery.ajax({
				type: 'POST',
				url: pctVars.ajax_url,
				data: data,
				success: function( response ){
					let link = document.createElement('a');
					link.href = response.data.pdf.replace(/"/g, '').trim();
					link.setAttribute('download', filename);
					document.body.appendChild(link); // Required for Firefox
					link.click(); // Trigger the download
					document.body.removeChild(link); // Clean up
				},
				error: function( response ){
					console.log( response );
				},
				complete: function( response ){
					// console.log( response );
				}
			});
		});

		// Remove all items from multiselect
		jQuery( '.form-section' ).on( 'click', '.multiselect-clear', function( event ){
			event.preventDefault();

			let items = jQuery( this ).closest('.form-section').find('.multiselect-item');
			items.remove();

			jQuery( '.multiselect-input' ).val( '' );
		});

		// Remove all items from multiselect
		jQuery( '.form-section.products-select' ).on( 'click', '.multiselect-show-all', function( event ){
			event.preventDefault();

			let whisperContainer = jQuery( this ).closest('.form-section').find('.whisper-container').first();
			let isActive = whisperContainer.hasClass('active');
			if(!isActive) {
				profile.fillWhisper(userVariables.api_organization_products, jQuery( this ));
			}else{
				whisperContainer.removeClass('active');
			}
		});

		jQuery( '.form-section.users-select' ).on( 'click', '.multiselect-show-all', function( event ){
			event.preventDefault();

			let whisperContainer = jQuery( this ).closest('.form-section').find('.whisper-container').first();
			let isActive = whisperContainer.hasClass('active');
			if(!isActive) {
				profile.fillWhisper(userVariables.api_organization_users, jQuery( this ));
			}else{
				whisperContainer.removeClass('active');
			}
		});

		// Remove item from multiselect
		jQuery( '.multiselect' ).on( 'click', '.remove', function( event ){
			let id = jQuery( this ).data( 'id' );
			jQuery( `.multiselect-item[data-id="${id}"]` ).remove()
		});

		// Productremove whisper input search change
		jQuery('#product-select-input').on('keyup', function() {
			profile.refreshWhisper(jQuery(this), userVariables.api_organization_products);
		});

		// Users whisper input search change
		jQuery('#users-select-input').on('keyup', function() {
			profile.refreshWhisper(jQuery(this), userVariables.api_organization_users);
		});

		// Whisper click
		jQuery(document).on('click', '.whisper-container div', function() {
			profile.useWhisper(jQuery(this));
		});
	},

	fillWhisper: function( data, sourceElm ) {
		let whisperContainer = sourceElm.closest('.form-section').find('.whisper-container').first();
		if( data.length > 0 ) {
			whisperContainer.html('');

			data.forEach(function( item, key ){
				whisperContainer.append(`<div data-id="${item.id}" data-name="${item.name}">${item.name}</div>`);
			});
			whisperContainer.addClass('active');
		}else{
			whisperContainer.removeClass('active');
		}
	},

	useWhisper: function( whisperElm ) {
		let productId = whisperElm.data('id');
		let productName = whisperElm.data('name');
		let formSection = whisperElm.closest('.form-section');
		let whisperDest = formSection.find('.multiselect').first();

		if (whisperDest.find('.multiselect-item[data-id="' + productId + '"]').length === 0) {
			let input = formSection.find('.multiselect-input');
			let newItem = '<span class="multiselect-item" data-id="' + productId + '">' + productName + ' <span class="remove" data-sikmon="closeDelete" data-id="' + productId + '"></span></span>';
			whisperDest.append(newItem);

			input.val('');
			input.focus();
			whisperElm.closest('.whisper-container').removeClass('active');
		}
	},

	refreshWhisper: function(sourceElm, data) {
		let searchString = sourceElm.val().toLowerCase();
		if (searchString && data.length > 0) {
			let filteredData = data.filter(function(item) {
				return item.name.toLowerCase().includes(searchString);
			});
			profile.fillWhisper(filteredData, sourceElm);
		} else {
			profile.fillWhisper([], sourceElm);
		}
	},

	getMultiselectAsArray: function( multiselect ) {
		let items = [];
		multiselect.find('.multiselect-item').each(function() {
			items.push(jQuery(this).data('id'));
		});
		return items;
	}
};

export { profile };